import { render, staticRenderFns } from "./component-des.vue?vue&type=template&id=d1e695ac&scoped=true&"
import script from "./component-des.vue?vue&type=script&lang=js&"
export * from "./component-des.vue?vue&type=script&lang=js&"
import style0 from "./component-des.vue?vue&type=style&index=0&id=d1e695ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e695ac",
  null
  
)

export default component.exports